import React from "react";

import SBCLinkCell from "ComparePlans/Components/SBCLinkCell";
import isIntuit from "Intuit/isIntuit";
import { isTrowserRollout } from "Intuit/TrowserUtils";
import { map } from "underscore";

import { Table, TR, TD, TH } from "Cobalt/TableV2";
import { Card, CardHeader, CardSection } from "Common/Card";

import makeBem from "Utils/makeBem";

const bem = makeBem("VisionPlanDetails");
export const DISPLAY_CATEGORIES = {
  Basic: ["Eye Examination", "Benefit Frequency Exams"],
  "Eyeglass Lenses": ["Eyeglass Lenses Single", "Eyeglass Lenses Bifocal", "Eyeglass Lenses Trifocal", "Benefit Frequency Lenses"],
  Frames: ["Frames", "Benefit Frequency Frames"],
  "Contact Lenses": ["Contact Lenses", "Benefit Frequency Lenses"],
};
export const DISPLAY_TERM_NAMES = {
  "Eye Examination": "Eye Exam",
  Frames: "Frames",
  "Eyeglass Lenses Single": "Single",
  "Eyeglass Lenses Bifocal": "Bifocal",
  "Eyeglass Lenses Trifocal": "Trifocal",
  "Contact Lenses": "Contact Lenses",
  "Benefit Frequency Exams": "How often? - Exams",
  "Benefit Frequency Lenses": "How often? - Lenses",
  "Benefit Frequency Frames": "How often? - Frames",
};

const TermRow = ({ term, plan, category }) => (
  <TR highlightFirstCell={false}>
    <TD>{DISPLAY_TERM_NAMES[term] || term}</TD>
    <TD>{plan.fine_print[category][term].inNetwork}</TD>
    <TD>{plan.fine_print[category][term].outNetwork}</TD>
  </TR>
);

const VisionPlanDetails = ({ plan, className }) => (
  <div className={bem()}>
    <Card theme="flat" p={0}>
      <CardHeader>Plan Overview</CardHeader>
      <CardSection>
        <Table className={className}>
          <tbody>
            <TR highlightFirstCell={false}>
              <TD className="w-2/5">Eye Exam</TD>
              <TD>{plan.eye_exam}</TD>
            </TR>
            <TR highlightFirstCell={false}>
              <TD className="w-2/5">Eyeglass Lenses</TD>
              <TD>{plan.lenses}</TD>
            </TR>
            <TR highlightFirstCell={false}>
              <TD className="w-2/5">Eyeglass Frames</TD>
              <TD>{plan.frames}</TD>
            </TR>
            <TR highlightFirstCell={false}>
              <TD className="w-2/5">Contact Lenses</TD>
              <TD>{plan.contacts}</TD>
            </TR>
            <TR highlightFirstCell={false}>
              <TD className="w-2/5">Plan Document</TD>
              <TD>
                <SBCLinkCell plan={plan} />
              </TD>
            </TR>
          </tbody>
        </Table>
      </CardSection>
    </Card>

    <Card theme="flat" className="common-plan-section" p={0}>
      <CardHeader level={isIntuit() && isTrowserRollout() ? 8 : 3}>Plan Details</CardHeader>
      <CardSection>
        <Table>
          <thead>
            <TR>
              <TH className="w-2/5">Plan Term</TH>
              <TH className="w-1/5"> In Network</TH>
              <TH className="w-2/5">Out of Network</TH>
            </TR>
          </thead>
          {map(DISPLAY_CATEGORIES, (terms, category) => (
            <tbody key={category}>
              <TR>
                <TH colSpan={3}>{category}</TH>
              </TR>
              {map(terms, (term) => (
                <TermRow term={term} plan={plan} category={category} key={term} />
              ))}
            </tbody>
          ))}
        </Table>
      </CardSection>
    </Card>
  </div>
);

export default VisionPlanDetails;
